export const FileUploadFormStyles = {
    btnsContainer: {
        marginTop: "16px",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-around"
    }
}
